var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import DateAndTimePicker from '@declaration/components/UI/DateAndTimePicker.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { formatDate, isValidDate } from '@shared/utils/date';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let ScheduledRepairDateQuestion = class ScheduledRepairDateQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.minDate = null;
        this.scheduledRepairDate = null;
    }
    mounted() {
        var _a;
        this.minDate = new Date();
        this.minDate.setHours(0, 0, 0, 0);
        this.scheduledRepairDate = ((_a = this.claim) === null || _a === void 0 ? void 0 : _a.scheduledRepairDate)
            ? new Date(this.claim.scheduledRepairDate)
            : null;
    }
    get typeTrigram() {
        var _a, _b;
        return (_b = (_a = this.claimTypeTrigram) !== null && _a !== void 0 ? _a : this.qualificationTypeTrigram) !== null && _b !== void 0 ? _b : undefined;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink, this.typeTrigram);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.claimDate) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    get panelTitle() {
        return this.$tc('claim.declaration.section.reparation_date.title');
    }
    get sidebarTitle() {
        const key = 'claim.date.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        var _a;
        const date = (_a = this.claim) === null || _a === void 0 ? void 0 : _a.scheduledRepairDate;
        if (!date)
            return null;
        const formatedDate = formatDate(new Date(date), this.$i18n.locale);
        return this.$tc('claim.declaration.section.reparation_date.sumup', 0, { date: formatedDate });
    }
    get canValidate() {
        return isValidDate(this.scheduledRepairDate, { min: this.minDate });
    }
    async handleNotPlannedReparationDate() {
        this.scheduledRepairDate = null;
        await this.updateAndSaveClaim({
            claimPayload: { scheduledRepairDate: null },
            step: this.step,
        });
    }
    validate() {
        if (!this.canValidate)
            return;
        this.updateAndSaveClaim({
            claimPayload: { scheduledRepairDate: this.scheduledRepairDate.toISOString() },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('claim')
], ScheduledRepairDateQuestion.prototype, "claim", void 0);
__decorate([
    claim.State('claimTypeTrigram')
], ScheduledRepairDateQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('typeTrigram')
], ScheduledRepairDateQuestion.prototype, "qualificationTypeTrigram", void 0);
__decorate([
    claim.State('isUpdatingClaim')
], ScheduledRepairDateQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.Action('updateAndSaveClaim')
], ScheduledRepairDateQuestion.prototype, "updateAndSaveClaim", void 0);
__decorate([
    settings.Getter('setting')
], ScheduledRepairDateQuestion.prototype, "setting", void 0);
ScheduledRepairDateQuestion = __decorate([
    Component({
        components: { QuestionPanel, DateAndTimePicker, UiButton },
        props: QuestionProps,
    })
], ScheduledRepairDateQuestion);
export default ScheduledRepairDateQuestion;
